import { z } from 'zod';
import { AddressSchema } from '../common-tools';
import { UserNotificationPreferencesSchema, UserNotificationPreferencesViewSchema, } from '../app-notification';
export const BusinessUserProfileV2Schema = z.object({
    name: z.string().min(1),
    email: z.string().email(),
    phone: z.string().min(1).optional(),
    address: AddressSchema.optional(),
});
export const BusinessUserV2Schema = z.object({
    id: z.string().min(1),
    businessId: z.string().min(1),
    roleId: z.string().min(1),
    profile: BusinessUserProfileV2Schema,
    isActive: z.boolean(),
    isDefault: z.boolean().default(false),
    notificationPreferences: UserNotificationPreferencesSchema.optional().default({}),
    /** Caller-safe effective preference and role-capability view. */
    notificationPreferenceView: UserNotificationPreferencesViewSchema.optional(),
    /**
     * Only a derived credential belongs here. Raw four-digit PINs must never be
     * stored in this V2 contract.
     */
    pinHash: z
        .string()
        .min(20, 'pinHash must contain a derived credential, not a raw PIN')
        .optional(),
});
